<template>
  <div class="age-restriction-step-plain">
    <div class="row">
      <div class="col-9">
        <v-select
          ref="categoryId"
          v-model="categoryId"
          :class="{disable: disabled}"
          :required="!disabled"
          label="Категория"
          name="categoryId"
          :rules="modelValidations.categoryId"
          :disabled="disabled"
          :input-settings="{placeholder: ' '}"
          :options="types.restriction"
          @validated="handleValidate"/>
      </div>
    </div>
    <div v-if="!!selectedCategory" class="restriction-answer-list custom-scroll">
      <age-restriction-question
        v-for="child in selectedCategory.children"
        :key="child.id"
        :init-answer="initAnswer"
        :disabled="disabled"
        :data="child"
        @changeAnswer="handleAnswerChange"/>
    </div>
  </div>
</template>

<script>
import AgeRestrictionQuestion from './AgeRestrictionQuestion'
import { mapGetters } from 'vuex'
import { UUID_REGEX } from '@/utils/regexp'
import VSelect from '@/components/UIComponents/Custom/VSelect'

export default {
    name: "AgeRestrictionStepPlain",
    components: {
      VSelect,
      AgeRestrictionQuestion,
    },
    props: {
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        categoryId: '',
        modelValidations: {
          categoryId: {
            required: true,
          }
        },
        valid: {
          categoryId: undefined
        },
        validChecked: false,
        restriction: null,
        selectedCategory: null,
        addedAnswer: [],
        removedAnswer: [],
      }
    },
    computed: {
      ...mapGetters(['types', 'selectedApplication']),
      isInitCategory() {
        return this.selectedApplication && this.selectedApplication.restriction_id === this.categoryId
      },
      initAnswer() {
        const showAnswerFromApp = [
          this.selectedApplication,
          this.selectedApplication.answer,
          this.selectedApplication.answer !== 'null',
          this.selectedApplication.answer[0],
          this.isInitCategory
        ].every(i => !!i)
        return showAnswerFromApp ? [...this.selectedApplication.answer] : []
      },
      answer() {
        return this.initAnswer.concat(this.addedAnswer).filter(item => !this.removedAnswer.includes(item))
      },
    },
    methods: {
      handleValidate({ name, valid }) {
        this.valid[name] = valid
      },
      async validate() {
        this.validChecked = true

        await Promise.allSettled(Object.keys(this.valid).map(key => this.$refs[key]?.trigger()))

        const isValid = Object.entries(this.valid).every(([key, value]) => {
          const filled = this.modelValidations[key]?.required ? value === true : true
          const correct = value !== false
          return filled && correct
        })
        this.$emit('on-validated', isValid, {
          restriction_id: this.selectedCategory.id,
          answer: this.answer,
        })
        return isValid
      },
      handleCategoryChange(id) {
        this.removedAnswer = []
        this.addedAnswer = []
        this.selectedCategory = JSON.parse(JSON.stringify(this.restriction.find(item => item.id === id)))
      },
      handleAnswerChange(payload) {
        const {value, names} = payload
        if (value === true) {
          const name = names[0]
          if (!this.initAnswer.includes(name) && !this.addedAnswer.includes(name)) {
            this.addedAnswer.push(name)
          }
          this.removedAnswer = this.removedAnswer.filter(item => item !== name)
        } else if (value === false) {
          for (const name of names) {
            if (!this.removedAnswer.includes(name)) this.removedAnswer.push(name)
          }
        }
      }
    },
    beforeMount() {
      this.restriction = JSON.parse(JSON.stringify(this.types.restriction.filter(item => !item.name.match(UUID_REGEX))))
      if (this.selectedApplication) {
        const id = this.selectedApplication.restriction_id
        if (!id) return
        this.categoryId = id
        // хак для глубокого копирования массива
        this.selectedCategory = JSON.parse(JSON.stringify(this.restriction.find(item => item.id === id)))
      }
    },
  }
</script>

<style scoped>

</style>
